export default __webpack_public_path__ + "static/media/IndependenceNew7.313c5cf7.JPG";